import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, TextField, Tooltip, Typography } from "@mui/material"
import { useState } from "react"
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { addRelatedLoansApi, updateRelatedLoansApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { useDispatch, useSelector } from "react-redux";
import { formatBytes } from "../../../../utils/fileUpload";
import { regexConstants } from "../../../../constants/regEx";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";

const RelatedLoansCRU = ({ addEditRelatedLoans, modeType, fileUpload, onToggleModal, params, getResponseBack, onOpenAttachments }) => {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const {storageDetails } = useSelector((state) => state.leases);
    const [addEditRelatedLoansData, setAddEditRelatedLoansData] = useState(addEditRelatedLoans.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const onAddEditRelatedLoans = () => {
        let validationInputs = {}
        validationInputs = {
            name: addEditRelatedLoansData?.name ? "" : "Please enter Name"
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
            setLoading(true);
            if (addEditRelatedLoansData.id) {
                globalPutService(updateRelatedLoansApi({ ...params, slug: addEditRelatedLoansData.slug }), addEditRelatedLoansData).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length ) {
                          fileUpload(addEditRelatedLoansData.slug,'updated');
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Related Loan`, success_msg: response?.data?.message, item_id: addEditRelatedLoansData?.id, payload: addEditRelatedLoansData, response: response?.data })
                    }
                    else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        trackActivity('Item Edited', { page_title: `Edit Related Loan`, error_msg: response?.data?.message, item_id: addEditRelatedLoansData?.id, payload: addEditRelatedLoansData, response: response?.data })
                    }
                })
            }
            else {
                globalPostService(addRelatedLoansApi({ leaseSlug: params.leaseSlug }), addEditRelatedLoansData).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (uploadedFiles?.length > 0) {
                             fileUpload(response?.data?.data.slug,'created')
                        }
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        trackActivity('Item Added', { page_title: `Add Related Loan`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: addEditRelatedLoansData, response: response?.data })
                    }
                    else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                        trackActivity('Item Added', { page_title: `Add Related Loan`, error_msg: response?.data?.message, item_id: null, payload: addEditRelatedLoansData, response: response?.data })
                    }
                })
            }
        }
        else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Related Loan`, error_msg: validationInputs, })
        }
    }
    const handleFileChanges = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({attachments:files}))
    }
    const onFieldChange = (key, value) => {
        setAddEditRelatedLoansData({ ...addEditRelatedLoansData, [key]: value });
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Related Loan`, page_type: page_type, })
    }
    return (
        <>
            <Dialog open={addEditRelatedLoans.modal}
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add" : modeType === "edit" ? "Edit" : "View"} Related Loan
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} direction="column">
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Tooltip title={addEditRelatedLoansData?.name?.length > 23 ? addEditRelatedLoansData?.name : ""} placement="bottom" arrow>
                                <TextField
                                    value={addEditRelatedLoansData?.name || ""}
                                    disabled={modeType === "view"}
                                    required
                                    label="Name"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{
                                        inputLabel: { shrink: true },
                                        htmlInput: { maxLength: 255 }
                                    }}
                                    fullWidth
                                    helperText={error.name}
                                    error={error.name}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, name: "" }));
                                    }} />
                            </Tooltip>
                        </Grid>
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Description' value={addEditRelatedLoansData?.description || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    value={addEditRelatedLoansData?.description || ""}
                                    disabled={modeType === "view"}
                                    label="Description"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("description", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, description: "" }));
                                    }}
                                    />
                            </Grid>}
                        <Grid size={{ md: 6, xs: 12 }}>
                            <FormGroup>
                                <Box className="check-item-div" sx={{cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                                    <Checkbox checked={addEditRelatedLoansData.loan_status} onChange={(e) => { onFieldChange("loan_status", e.target.checked) }} disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0 }} />
                                    <span className="check-item-span file-name">Loan Status</span>
                                </Box>
                            </FormGroup>
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                            {
                                addEditRelatedLoansData?.id && addEditRelatedLoansData?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button')}} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`${addEditRelatedLoansData?.attachments?.length}: Attachments`}</Button> : null
                            }
                             <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChanges} attachments={addEditRelatedLoansData?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : 
                    <Button variant="contained" className="btn-primary" size="small" onClick={() => { handleItemClicked('Save Button'); onAddEditRelatedLoans() }}>{isLoading ? <CircularProgress color="inherit" size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}
export default RelatedLoansCRU;
